<template lang="pug">
  header.site-header
    .site-header__logo
      slot(name="logo")

    .site-header__navigation(
      v-if="$mq !== 'mobile' && $mq !== 'tablet'"
    )
      slot(name="primary-navigation")

    .site-header__utility-nav
      slot(name="utility-nav")

    .site-header__mobile-nav(
      v-if="$mq === 'mobile' || $mq === 'tablet'"
    )
      slot(name="mobile-navigation")

</template>

<script>
  export default {
    name: 'SiteHeader',
  };
</script>

<style lang="scss">
  .site-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin: 0 auto;
    padding: 0 ($spacing-unit * 4);
    height: $mobile-nav-height;
    max-width: $container-max-width;
    background-color: $bg--main;

    @include desktop-up {
      height: $desktop-nav-height;
    }
  }

  .site-header__mobile-nav {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .site-header__logo {
    width: 200px;

    @include desktop-up {
      position: relative;
      flex-shrink: 0;
    }
  }

  .site-header__navigation {
    margin-left: auto;
  }

  .site-header__utility-nav {
    display: flex;
    align-items: center;
    text-align: right;
    margin-left: auto;

    @include desktop-up {
      flex-basis: auto;
    }
  }
</style>
